import {FC, useEffect, useState} from 'react'
import {PieChart} from '../../../../_metronic/partials/widgets/charts/PieChart'
import {getDataDashBoard} from '../../../modules/insurance/healthInsurance/apis'
import {
  AllMessages,
  GetDateRange,
  GetListYears,
  formatter,
  getListProduct,
  messageError,
  useLocalStorage,
  useWindowDimensions,
} from '../../../utils'
import moment from 'moment'
import {Button, FormControl, FormControlLabel, Radio, RadioGroup} from '@mui/material'
import {AutoComplete, InputDatePicker, MapCustom, PopoverCustom, SelectField} from '../../../components'
import {ColumnLineChart} from '../../../../_metronic/partials/widgets/charts/ColumnLineChart'
import clsx from 'clsx'
import {TableComponentBancas} from '../../../../_metronic/partials/widgets'
import * as component from '../../../components/redux/componentRedux'
import * as filter from '../../../redux-commons/FilterRedux/filterRedux'
import {useDispatch, useSelector} from 'react-redux'
import {ColumnLineChartNew} from '../../../../_metronic/partials/widgets/charts/ColumnLineChartNew'
import {RootState} from '../../../../setup'
import {Lang} from '../../../modules/auth/apis'

export interface FilterModel {
  timeType: string
  dashBoardType: string
  startDate: string
  expireDate: string
  partner: string
  exploitingCode: string
  division: string
  customer: string
  product: string
  groupdomain: string
  contractType: string
  compare: string
}

export interface ChartRevenueModel {
  productName: string
  dataDate: string[]
  dataRevenue: number[]
  dataContract: number[]
}

export interface ChartRenewModel {
  dataType: string[]
  dataContract: number[]
}

const listMonth = [
  {value: '1', label: '1'},
  {value: '2', label: '2'},
  {value: '3', label: '3'},
  {value: '4', label: '4'},
  {value: '5', label: '5'},
  {value: '6', label: '6'},
  {value: '7', label: '7'},
  {value: '8', label: '8'},
  {value: '9', label: '9'},
  {value: '10', label: '10'},
  {value: '11', label: '11'},
  {value: '12', label: '12'},
]

const SummaryHealthInsurances: FC = () => {
  const [filterForm, setFilterForm] = useState('')
  const [dataChartRenewOrigin, setDataChartRenewOrigin] = useState<any>()
  const [listProductInsurance, setListProductInsurance] = useState<any>([])
  const [listCompare, setListCompare] = useState<string[]>([])
  const [dataChartRevenue, setDataChartRevenue] = useState<ChartRevenueModel>({
    productName: '',
    dataDate: [],
    dataRevenue: [],
    dataContract: [],
  })
  const [dataChartRevenueNew, setDataChartRevenueNew] = useState<ChartRevenueModel>({
    productName: '',
    dataDate: [],
    dataRevenue: [],
    dataContract: [],
  })
  const [dataChartRenew, setDataChartRenew] = useState<ChartRenewModel>({
    dataType: [],
    dataContract: [],
  })
  const [stateFilter, setStateFilter] = useState<FilterModel>({
    timeType: 'month',
    dashBoardType: 'REVENUE',
    startDate: moment().startOf('year').format('DD/MM/YYYY'),
    expireDate: moment().endOf('year').format('DD/MM/YYYY'),
    partner: '',
    exploitingCode: '',
    division: '',
    customer: '',
    product: 'P_I',
    groupdomain: '',
    contractType: '',
    compare: '',
  })
  const [stateFilterRenew, setStateFilterRenew] = useState<FilterModel>({
    timeType: '2024',
    dashBoardType: 'RENEW',
    startDate: moment().startOf('year').format('DD/MM/YYYY'),
    expireDate: moment().endOf('year').format('DD/MM/YYYY'),
    partner: '',
    exploitingCode: '',
    division: '',
    customer: '',
    product: '',
    groupdomain: '',
    contractType: '',
    compare: '',
  })
  const [dataTableRenew, setDataTableRenew] = useState<any>([])
  const [showChartDetail, setShowChartDetail] = useState(false)
  const [division] = useLocalStorage<any[]>('view:division', [])
  const [partner] = useLocalStorage<any[]>('view:partner', [])
  const [lang] = useLocalStorage<Lang>('i18nConfig', {selectedLang: 'vi'})
  const filterState = useSelector((state: RootState) => state.filter).FilterDashboard
  const filterStatus = useSelector((state: RootState) => state.filter).applyFilter
  const {width} = useWindowDimensions()
  const dispatch = useDispatch()
  const [viewport, setViewport] = useState({
    latitude: 21.03072,
    longitude: 105.85239,
    zoom: 12,
  })
  const columnCustomer = [
    {
      field: 'id',
      headerName: 'TOP',
      headerAlign: 'center',
      align: 'center',
      minWidth: 40,
      maxWith: 40,
      sortable: false,
      renderCell: (params: any) => (
        <p style={{color: params.value < 4 ? 'red' : 'inherit'}}>{params.value}</p>
      ),
    },
    {
      field: 'name',
      headerName: AllMessages[lang.selectedLang].TEN_KHACH_HANG,
      headerAlign: 'center',
      align: 'left',
      minWidth: 250,
      with: 250,
      flex: 1,
      sortable: false,
    },
    {
      field: 'count',
      headerName: AllMessages[lang.selectedLang].SO_DON,
      minWidth: 70,
      maxWidth: 70,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'sumfeeFormat',
      headerName: AllMessages[lang.selectedLang].TONG_PHI_BAO_HIEM_VND,
      headerAlign: 'center',
      minWidth: 160,
      maxWidth: 160,
      sortable: false,
      align: 'center',
      flex: 1,
    },
  ]

  const columnAgent = [
    {
      field: 'id',
      headerName: 'TOP',
      headerAlign: 'center',
      align: 'center',
      minWidth: 40,
      maxWith: 40,
      sortable: false,
      renderCell: (params: any) => (
        <p style={{color: params.value < 4 ? 'red' : 'inherit'}}>{params.value}</p>
      ),
    },
    {
      field: 'name',
      headerName: AllMessages[lang.selectedLang].DAI_LY,
      headerAlign: 'center',
      align: 'left',
      minWidth: 250,
      with: 250,
      flex: 1,
      sortable: false,
    },
    {
      field: 'count',
      headerName: AllMessages[lang.selectedLang].SO_DON,
      minWidth: 70,
      maxWidth: 70,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'sumfeeFormat',
      headerName: AllMessages[lang.selectedLang].TONG_PHI_BAO_HIEM_VND,
      headerAlign: 'center',
      minWidth: 160,
      maxWidth: 160,
      sortable: false,
      align: 'center',
      flex: 1,
    },
  ]

  const columnRenew = [
    {field: 'id', headerName: 'STT', minWidth: 30, maxWidth: 50, hide: true, sortable: false},
    {
      field: 'type',
      headerName: AllMessages[lang.selectedLang].DASHBOARD_NOI_DUNG,
      headerAlign: 'center',
      align: 'center',
      minWidth: 180,
      maxWidth: 200,
      flex: 1,
      sortable: false,
      renderCell: (params: any) => (
        <p
          className={clsx(`fs-8 fw-bolder`, {
            'badge-light-danger':
              params.value.toLowerCase().includes('từ chối') ||
              params.value.toLowerCase().includes('refuse'),
            'badge-light-warning-renew':
              params.value.toLowerCase().includes('chờ') ||
              params.value.toLowerCase().includes('waiting'),
            'badge-light-success':
              params.value.toLowerCase().includes('thành công') ||
              params.value.toLowerCase().includes('successful'),
            'badge-light-primary': params.value.toLowerCase().includes('trình'),
          })}
          style={{backgroundColor: 'transparent'}}
        >
          {params.value}
        </p>
      ),
    },
    {
      field: 'contract',
      headerName: AllMessages[lang.selectedLang].DASHBOARD_SO_HD_CON,
      minWidth: 130,
      maxWidth: 200,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'insured',
      headerName: AllMessages[lang.selectedLang].DASHBOARD_SO_NDBH,
      minWidth: 130,
      maxWidth: 200,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'fee',
      headerName: AllMessages[lang.selectedLang].TONG_PHI_BAO_HIEM_VND,
      headerAlign: 'center',
      minWidth: 130,
      maxWidth: 200,
      sortable: false,
      align: 'center',
      flex: 1,
    },
    {
      field: 'reNewFee',
      headerName: AllMessages[lang.selectedLang].DASHBOARD_PHI_TAI_TUC_VND,
      headerAlign: 'center',
      minWidth: 130,
      maxWidth: 200,
      sortable: false,
      align: 'center',
      flex: 1,
    },
  ]

  const handleChangeTypeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = (event.target as HTMLInputElement).value
    if (value == 'day') {
      setStateFilter((preState) => {
        return {
          ...preState,
          timeType: value,
          startDate: moment().subtract(21, 'day').format('DD/MM/YYYY'),
          expireDate: moment().format('DD/MM/YYYY'),
          compare: '',
        }
      })
    }
    if (value == 'month') {
      setStateFilter((preState) => {
        return {
          ...preState,
          timeType: value,
          startDate: moment().startOf('year').format('DD/MM/YYYY'),
          expireDate: moment().endOf('year').format('DD/MM/YYYY'),
          compare: '',
        }
      })
    }
    if (value == 'year') {
      setStateFilter((preState) => {
        return {
          ...preState,
          timeType: value,
          startDate: moment().startOf('year').subtract(1, 'year').format('DD/MM/YYYY'),
          expireDate: moment().format('DD/MM/YYYY'),
          compare: '',
        }
      })
    }
    if (value == 'compare') {
      setStateFilter((preState) => {
        return {
          ...preState,
          timeType: value,
        }
      })
    }
  }

  const handleSaveDataFilter = (data: string, dataSource: any, key: string) => {
    let arr = data.split(',')
    let result: any = []
    arr.forEach((elem) => {
      let test = dataSource.find((o: any) => o.value == elem)
      if (test) {
        let obj = {
          label: test.label,
          value: test.value,
        }
        result.push(obj)
      }
    })
    dispatch(
      filter.actions.updateFilterInfo({
        field: key,
        value: JSON.stringify(result),
        filterForm: 'FilterDashboard',
      })
    )
  }

  const handleClickFilterMore = (type: string) => {
    if (type != filterForm) {
      dispatch(filter.actions.cleanFilterInfo('FilterDashboard'))
    }
    if (type == 'renew') {
      if (stateFilterRenew.division) {
        handleSaveDataFilter(stateFilterRenew.division, division, 'division')
      }
      if (stateFilterRenew.exploitingCode) {
        handleSaveDataFilter(stateFilterRenew.exploitingCode, partner, 'exploitingCode')
      }
      if (stateFilterRenew.customer) {
        dispatch(
          filter.actions.updateFilterInfo({
            field: 'customer',
            value: stateFilterRenew.customer,
            filterForm: 'FilterDashboard',
          })
        )
      }
    }
    if (type == 'revenue') {
      if (stateFilter.division) {
        handleSaveDataFilter(stateFilter.division, division, 'division')
      }
      if (stateFilter.exploitingCode) {
        handleSaveDataFilter(stateFilter.exploitingCode, partner, 'exploitingCode')
      }
      if (stateFilter.customer) {
        dispatch(
          filter.actions.updateFilterInfo({
            field: 'customer',
            value: stateFilter.customer,
            filterForm: 'FilterDashboard',
          })
        )
      }
    }
    setFilterForm(type)
  }

  const handleChangeStartDateRenew = (date: string) => {
    setStateFilterRenew((preState) => {
      return {
        ...preState,
        startDate: moment(date).startOf('month').format('DD/MM/YYYY'),
      }
    })
  }

  const handleChangeExpireDateRenew = (date: string) => {
    setStateFilterRenew((preState) => {
      return {
        ...preState,
        expireDate: moment(date).endOf('month').format('DD/MM/YYYY'),
      }
    })
  }

  const handleChangeStartDate = (date: string) => {
    if (stateFilter.timeType == 'day') {
      let endDate = moment(date, 'YYYY/MM/DD').add(21, 'day')
      let test = moment(endDate).isSameOrAfter(moment().toDate())
      if (test) {
        setStateFilter((preState) => {
          return {
            ...preState,
            startDate: moment(date).format('DD/MM/YYYY'),
            expireDate: moment().format('DD/MM/YYYY'),
          }
        })
      } else {
        setStateFilter((preState) => {
          return {
            ...preState,
            startDate: moment(date).format('DD/MM/YYYY'),
            expireDate: endDate.format('DD/MM/YYYY'),
          }
        })
      }
    } else {
      setStateFilter((preState) => {
        return {...preState, startDate: moment(date).format('DD/MM/YYYY')}
      })
    }
  }

  const handleChangeExpireDate = (date: string) => {
    if (stateFilter.timeType == 'day') {
      setStateFilter((preState) => {
        return {
          ...preState,
          expireDate: moment(date).format('DD/MM/YYYY'),
          startDate: moment(date).subtract(21, 'day').format('DD/MM/YYYY'),
        }
      })
    } else {
      setStateFilter((preState) => {
        return {...preState, expireDate: moment(date).format('DD/MM/YYYY')}
      })
    }
  }

  const handleFocusColumn = (data: any) => {
    if (data) setShowChartDetail(true)
  }

  const handleProductInsuranceChange = (data: string) => {
    setStateFilter((preState) => {
      return {...preState, product: data}
    })
  }

  const handleFilterCompare = () => {
    setStateFilter((preState) => {
      return {...preState, compare: listCompare.toString(), startDate: '', expireDate: ''}
    })
  }

  const getSumFeeContract = (arrFilter: any, dataFilter: FilterModel) => {
    let fee = 0
    let contract = 0
    arrFilter.forEach((elem: any) => {
      if (dataFilter.exploitingCode && !dataFilter.exploitingCode.includes(elem?.exploitingCode)) {
        fee += 0
        contract += 0
        return
      }
      if (dataFilter.division && !dataFilter.division.includes(elem.divisionCode)) {
        fee += 0
        contract += 0
        return
      }
      fee += elem.sumfee
      contract += elem.totalContract
    })
    return {fee: fee, contract: contract}
  }

  const handleSetDateRange = (type: string, arrDates: string[]) => {
    if (type == 'total') {
      setDataChartRevenue((preState) => {
        return {...preState, dataDate: arrDates}
      })
    } else {
      setDataChartRevenueNew((preState) => {
        return {...preState, dataDate: arrDates}
      })
    }
  }

  const filterDataRevenue = (dataFilter: FilterModel, dataRevenue: any, type: string) => {
    let filterMonth = true
    let arrDates: string[] = []
    let data = JSON.parse(JSON.stringify(dataRevenue))
    data = data.filter(
      (o: any) => o.productCode == stateFilter.product && o.type == 'Doanh thu thực thu'
    )
    if (type == 'total') {
      setDataChartRevenue((preState) => {
        return {
          ...preState,
          productName: listProductInsurance.find((o: any) => o.value == stateFilter.product)?.label,
        }
      })
    } else {
      setDataChartRevenueNew((preState) => {
        return {
          ...preState,
          productName: listProductInsurance.find((o: any) => o.value == stateFilter.product)?.label,
        }
      })
    }

    let arrFee: number[] = []
    let arrContract: number[] = []
    var start = moment(dataFilter.startDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
    var end = moment(dataFilter.expireDate, 'DD/MM/YYYY').format('YYYY/MM/DD')
    if (dataFilter.timeType == 'day') {
      arrDates = GetDateRange(start, end, 'day')
      handleSetDateRange(type, arrDates)
      arrDates.forEach((o) => {
        let arrFilter = data.filter(
          (elem: any) =>
            (elem.day.toString().length == 1 ? '0' + elem.day.toString() : elem.day.toString()) +
              '/' +
              (elem.month.toString().length == 1
                ? '0' + elem.month.toString()
                : elem.month.toString()) +
              '/' +
              elem.year.toString() ==
            o
        )
        if (arrFilter.length > 0) {
          let data = getSumFeeContract(arrFilter, dataFilter)
          arrFee.push(data.fee)
          arrContract.push(data.contract)
        } else {
          arrFee.push(0)
          arrContract.push(0)
        }
      })
    }
    if (dataFilter.timeType == 'month') {
      if (dataFilter.startDate && dataFilter.expireDate) {
        arrDates = GetDateRange(start, end, 'month')
        handleSetDateRange(type, arrDates)
      }
      if (arrDates.length > 24) {
        filterMonth = false
      } else {
        arrDates.forEach((o) => {
          let arrFilter = data.filter(
            (elem: any) =>
              (elem.month.toString().length == 1
                ? '0' + elem.month.toString()
                : elem.month.toString()) +
                '/' +
                elem.year.toString() ==
              o
          )
          if (arrFilter.length > 0) {
            let data = getSumFeeContract(arrFilter, dataFilter)
            arrFee.push(data.fee)
            arrContract.push(data.contract)
          } else {
            arrFee.push(0)
            arrContract.push(0)
          }
        })
      }
    }
    if (dataFilter.timeType == 'year' || !filterMonth) {
      if (dataFilter.startDate && dataFilter.expireDate) {
        arrDates = GetDateRange(start, end, 'year')
        handleSetDateRange(type, arrDates)
      }
      arrDates.forEach((o) => {
        let arrFilter = data.filter((elem: any) => elem.year.toString() == o)
        if (arrFilter.length > 0) {
          let data = getSumFeeContract(arrFilter, dataFilter)
          arrFee.push(data.fee)
          arrContract.push(data.contract)
        } else {
          arrFee.push(0)
          arrContract.push(0)
        }
      })
    }
    if (dataFilter.timeType == 'compare') {
      handleSetDateRange(type, listCompare)
      listCompare.forEach((o) => {
        let arrFilter = data.filter(
          (elem: any) =>
            (elem.month.toString().length == 1
              ? '0' + elem.month.toString()
              : elem.month.toString()) +
              '/' +
              elem.year.toString() ==
            o
        )
        if (arrFilter.length > 0) {
          let data = getSumFeeContract(arrFilter, dataFilter)
          arrFee.push(data.fee)
          arrContract.push(data.contract)
        } else {
          arrFee.push(0)
          arrContract.push(0)
        }
      })
    }
    if (type == 'total') {
      setDataChartRevenue((preState) => {
        return {...preState, dataRevenue: arrFee, dataContract: arrContract}
      })
    } else {
      setDataChartRevenueNew((preState) => {
        return {...preState, dataRevenue: arrFee, dataContract: arrContract}
      })
    }
  }

  const filterDataRenew = (dataFilter: FilterModel, dataRenew: any) => {
    let data = JSON.parse(JSON.stringify(dataRenew))
    let arrRenewType: string[] = []
    let arrRenewContract: number[] = []
    let dataTable: any = []
    // data = data.filter((o: any) => o.year.toString() == dataFilter.timeType)
    data.forEach((elem: any) => {
      if (!arrRenewType.includes(elem.renewType)) {
        if (
          elem.renewType == 'Tái tục thành công' ||
          elem.renewType.toLowerCase().includes('successful')
        ) {
          arrRenewType.unshift(elem.renewType)
        } else arrRenewType.push(elem.renewType)
      }
    })
    arrRenewType.forEach((elem, i) => {
      let arrRenew = data.filter((o: any) => o.renewType == elem)
      if (arrRenew.length > 0) {
        let reNewFee = 0
        let fee = 0
        let contract = 0
        let insured = 0
        arrRenew.forEach((o: any) => {
          fee += o.sumfee
          contract += o.totalContract
          reNewFee += o.sumRenewFee
          insured += o.countObject
        })
        let obj = {
          id: i,
          type: elem,
          fee: formatter(fee),
          contract: contract,
          reNewFee: formatter(reNewFee),
          insured: insured,
        }
        dataTable.push(obj)
        arrRenewContract.push(contract)
      }
    })
    setDataChartRenew((preState) => {
      return {...preState, dataType: arrRenewType, dataContract: arrRenewContract}
    })
    setDataTableRenew(dataTable)
  }

  const getDataRevenue = () => {
    dispatch(component.actions.showBackdrop({show: true}))
    getDataDashBoard(stateFilter)
      .then((res: any) => {
        filterDataRevenue(stateFilter, res.data?._revenueDtos, 'total')
        filterDataRevenue(stateFilter, res.data?._revenueNewDtos, 'new')
        dispatch(component.actions.showBackdrop({show: false}))
        // filterDataRenew(stateFilterRenew, res.data?._countRenewDtos)
      })
      .catch((error: any) => {
        dispatch(component.actions.showBackdrop({show: false}))
        dispatch(
          component.actions.writeAlert({
            show: true,
            type: 'error',
            message: messageError(error.response),
          })
        )
      })
  }

  const getDataRenew = () => {
    dispatch(component.actions.showBackdrop({show: true}))
    getDataDashBoard(stateFilterRenew)
      .then((res: any) => {
        res.data._countTopCustomerDtos.forEach((elem: any, i: number) => {
          if (elem) {
            elem.id = i + 1
            elem.sumfeeFormat = formatter(elem.sumfee)
          }
        })
        res.data._countTopPartnerDtos.forEach((elem: any, i: number) => {
          if (elem) {
            elem.id = i + 1
            elem.sumfeeFormat = formatter(elem.sumfee)
          }
        })
        setDataChartRenewOrigin(res.data)
        filterDataRenew(stateFilterRenew, res.data?._countRenewDtos)
        dispatch(component.actions.showBackdrop({show: false}))
      })
      .catch((error: any) => {
        dispatch(component.actions.showBackdrop({show: false}))
        dispatch(
          component.actions.writeAlert({
            show: true,
            type: 'error',
            message: messageError(error.response),
          })
        )
      })
  }

  const handleChooseCompareDate = (year: string, month: string) => {
    setListCompare((preState) => {
      let state = [...preState]
      month = month.length == 1 ? '0' + month : month
      let string = month + '/' + year
      if (state.includes(string)) state = state.filter((o) => o != string)
      else {
        let i = 0
        let test = false
        let skip = false
        state.forEach((o, j) => {
          if (o.includes(year) && !skip) {
            test = true
            let string = o.substring(0, 2)
            if (month < string) {
              i = j
              skip = true
            } else {
              i = j + 1
            }
          }
        })
        if (test) state.splice(i, 0, string)
        else state.push(string)
      }
      return state
    })
  }

  useEffect(() => {
    if (listProductInsurance.length > 0) {
      if (stateFilter.timeType == 'compare') {
        if (!stateFilter.compare) return
        getDataRevenue()
      } else getDataRevenue()
    }
  }, [stateFilter, listProductInsurance])

  useEffect(() => {
    getDataRenew()
  }, [stateFilterRenew])

  useEffect(() => {
    if (filterStatus) {
      let arrExploitingCode: any = []
      let arrDivision: any = []
      if (filterState.exploitingCode) {
        let exploitingCodeParse = JSON.parse(filterState.exploitingCode)
        exploitingCodeParse.forEach((elem: any) => {
          arrExploitingCode.push(elem.value)
        })
      }
      if (filterState.division) {
        let divisionParse = JSON.parse(filterState.division)
        divisionParse.forEach((elem: any) => {
          arrDivision.push(elem.value)
        })
      }
      if (filterForm == 'revenue') {
        setStateFilter((preState) => {
          return {
            ...preState,
            exploitingCode: arrExploitingCode.toString(),
            division: arrDivision.toString(),
            customer: filterState.customer ? filterState.customer : '',
          }
        })
      }
      if (filterForm == 'renew') {
        setStateFilterRenew((preState) => {
          return {
            ...preState,
            exploitingCode: arrExploitingCode.toString(),
            division: arrDivision.toString(),
            customer: filterState.customer ? filterState.customer : '',
          }
        })
      }
      dispatch(filter.actions.updateApplyFilterStatus(false))
    }
  }, [filterStatus, filterState, filterForm])

  useEffect(() => {
    getListProduct().then((res: any) => {
      if (res && !res.isError) {
        setListProductInsurance(() => {
          let arr: any = []
          res.result.items.forEach((o: any) => {
            let obj = {
              value: o.code,
              label: o.name,
            }
            arr.push(obj)
          })
          return arr
        })
      }
    })
    // searchAndPagingUser
  }, [])

  return (
    <>
      <div className='dashboard-wrapper mb-xl-4'>
        <div className='card' style={{padding: '10px'}}>
          <h2 style={{fontWeight: '500'}}>Tổng doanh thu</h2>
          <div style={{display: 'flex', gap: '15px', alignItems: 'center'}}>
            <p>{AllMessages[lang.selectedLang].DASHBOARD_BO_LOC}: </p>
            <div>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby='demo-row-radio-buttons-group-label'
                  name='row-radio-buttons-group'
                  value={stateFilter.timeType}
                  onChange={handleChangeTypeFilter}
                >
                  <FormControlLabel
                    value='day'
                    control={<Radio />}
                    label={AllMessages[lang.selectedLang].DASHBOARD_NGAY}
                  />
                  <FormControlLabel
                    value='month'
                    control={<Radio />}
                    label={AllMessages[lang.selectedLang].DASHBOARD_THANG}
                  />
                  <FormControlLabel
                    value='year'
                    control={<Radio />}
                    label={AllMessages[lang.selectedLang].DASHBOARD_NAM}
                  />
                  <FormControlLabel
                    value='compare'
                    control={<Radio />}
                    label={AllMessages[lang.selectedLang].DASHBOARD_KY}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <Button
                size='medium'
                variant='contained'
                aria-label='directions'
                id='kt_drawer_filter_dashboard_toggle'
                sx={{padding: '6px 16px !important'}}
                onClick={() => handleClickFilterMore('revenue')}
              >
                Lọc thêm
              </Button>
            </div>
            {stateFilter.timeType != 'compare' && (
              <>
                <div>
                  <InputDatePicker
                    viewMonthYear={stateFilter.timeType == 'month'}
                    viewYearOnly={stateFilter.timeType == 'year'}
                    defaultValue={moment(stateFilter.startDate, 'DD/MM/YYYY').toDate()}
                    id='startDateDashboard'
                    label={AllMessages[lang.selectedLang].DASHBOARD_TU}
                    handleDateChange={handleChangeStartDate}
                  />
                </div>
                <div>
                  <InputDatePicker
                    viewMonthYear={stateFilter.timeType == 'month'}
                    viewYearOnly={stateFilter.timeType == 'year'}
                    defaultValue={moment(stateFilter.expireDate, 'DD/MM/YYYY').toDate()}
                    id='expireDateDashboard'
                    label={AllMessages[lang.selectedLang].DASHBOARD_TOI}
                    handleDateChange={handleChangeExpireDate}
                  />
                </div>
              </>
            )}
            {stateFilter.timeType == 'compare' && (
              <>
                <PopoverCustom
                  label={AllMessages[lang.selectedLang].DASHBOARD_CHON_KY}
                  handleClosePopover={handleFilterCompare}
                >
                  <>
                    {GetListYears(moment().subtract(2, 'year').year()).map((o, i) => (
                      <div className='compare-popover-content' key={i}>
                        <p className='compare-popover-content-title'>{o.label}</p>
                        <div className='compare-popover-content-month'>
                          {listMonth.map((e, j) => (
                            <div
                              onClick={() => handleChooseCompareDate(o.value, e.value)}
                              className={clsx({
                                active: listCompare.includes(
                                  (e.value.length == 1 ? '0' + e.value : e.value) + '/' + o.value
                                ),
                              })}
                              key={j}
                            >
                              {e.label}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </>
                </PopoverCustom>
              </>
            )}
          </div>
          <div>
            <AutoComplete
              id='productInsurance'
              options={listProductInsurance}
              label='Sản phẩm bảo hiểm'
              defaultValue={stateFilter.product}
              handleValueSelected={handleProductInsuranceChange}
            />
          </div>
          <div className='mt-8'>
            <div style={{display: 'flex', gap: '10px'}}>
              {/* <div className={clsx({'col-12': !showChartDetail, 'col-8': showChartDetail})}> */}
              <div className={clsx('chart-revenue', {toggle: showChartDetail})}>
                <ColumnLineChart
                  className='card-xl-stretch mb-xl-7'
                  dataChart={dataChartRevenue}
                  handleFocusColumn={handleFocusColumn}
                />
                <p className='chart-revenue-note'>
                  {AllMessages[lang.selectedLang].DASHBOARD_LUU_Y}
                </p>
              </div>
              {/* {showChartDetail && (
                <div>
                  <MonochromeChart
                    className='card-xl-stretch mb-xl-8'
                    data={dataChart}
                    year={year}
                  />
                </div>
              )} */}
            </div>
            <h2 style={{fontWeight: '500'}}>Doanh thu mua mới</h2>
            <div style={{display: 'flex', gap: '10px'}}>
              {/* <div className={clsx({'col-12': !showChartDetail, 'col-8': showChartDetail})}> */}
              <div className={clsx('chart-revenue', {toggle: showChartDetail})}>
                <ColumnLineChartNew
                  className='card-xl-stretch mb-xl-7'
                  dataChart={dataChartRevenueNew}
                  handleFocusColumn={handleFocusColumn}
                />
                <p className='chart-revenue-note'>
                  {AllMessages[lang.selectedLang].DASHBOARD_LUU_Y}
                </p>
              </div>
              {/* {showChartDetail && (
                <div>
                  <MonochromeChart
                    className='card-xl-stretch mb-xl-8'
                    data={dataChart}
                    year={year}
                  />
                </div>
              )} */}
            </div>
          </div>
        </div>
      </div>
      <div className='card' style={{padding: '10px'}}>
        <h2 style={{fontWeight: '500'}}>Tái tục</h2>
        <div style={{display: 'flex', gap: '15px', alignItems: 'center', marginBottom: '20px'}}>
          <p>{AllMessages[lang.selectedLang].DASHBOARD_BO_LOC}: </p>
          {/* <div style={{minWidth: width > 1500 ? '200px' : '150px'}}>
            <SelectField
              id='filterYearRenew'
              options={GetListYears(2021)}
              labelId='Năm'
              placeholder='chon'
              defaultValue={stateFilterRenew.timeType}
              handleChangeValue={handleChangeYearRenew}
            />
          </div>
          <div style={{minWidth: width > 1500 ? '200px' : '150px'}}>
            <SelectFieldMulti
              id='filterMonthRenew'
              options={listMonth}
              multiple={true}
              labelId='Tháng'
              placeholder='Chọn tháng'
              defaultValue={''}
              handleChangeValue={handleChangeMonthRenew}
            />
          </div> */}
          <div>
            <InputDatePicker
              viewMonthYear
              defaultValue={moment(stateFilterRenew.startDate, 'DD/MM/YYYY').toDate()}
              id='startDate'
              label={AllMessages[lang.selectedLang].DASHBOARD_TU}
              handleDateChange={handleChangeStartDateRenew}
            />
          </div>
          <div>
            <InputDatePicker
              viewMonthYear
              defaultValue={moment(stateFilterRenew.expireDate, 'DD/MM/YYYY').toDate()}
              id='expireDate'
              label={AllMessages[lang.selectedLang].DASHBOARD_TOI}
              handleDateChange={handleChangeExpireDateRenew}
            />
          </div>
          <div>
            <Button
              size='medium'
              variant='contained'
              aria-label='directions'
              id='kt_drawer_filter_dashboard_toggle'
              sx={{padding: '6px 16px !important'}}
              onClick={() => handleClickFilterMore('renew')}
            >
              Lọc thêm
            </Button>
          </div>
        </div>
        <div className='row'>
          <div className='col-7'>
            <p className='top-10-title'>Tái tục bảo hiểm hợp đồng Master</p>
            <TableComponentBancas
              rowData={dataTableRenew}
              column={columnRenew}
              heightTable='280px'
              handleClickRow={() => {}}
              pageSize={10}
              hidePagination
            />
          </div>
          <div className='col-5'>
            <PieChart className='card-xl-stretch mb-xl-8' dataChart={dataChartRenew} />
          </div>
        </div>
      </div>
      <div className='card mb-xl-4' style={{padding: '10px'}}>
        <div className='row'>
          <div className='col-6'>
            <p className='top-10-title'>Top 10 khách hàng năm</p>
            <TableComponentBancas
              rowData={dataChartRenewOrigin?._countTopCustomerDtos}
              column={columnCustomer}
              heightTable='250px'
              handleClickRow={() => {}}
              pageSize={10}
              hidePagination
            />
          </div>
          <div className='col-6'>
            <p className='top-10-title'>Top 10 đại lý năm</p>
            <TableComponentBancas
              rowData={dataChartRenewOrigin?._countTopPartnerDtos}
              column={columnAgent}
              heightTable='250px'
              handleClickRow={() => {}}
              pageSize={10}
              hidePagination
            />
          </div>
        </div>
        <h2 style={{fontWeight: '500'}}></h2>
      </div>
      <div className='row'>
        {/* <BarChart className='card-xl-stretch mb-xl-8' data={dataChart} /> */}
      </div>
    </>
  )
}

export {SummaryHealthInsurances}
